export const dash = 'DASH_TBR';
export const doubleDash = 'DOUBLE_DASH_TBR';
export const space = 'SPACE_TBR';
export const stringSpace = 'STRING_SPACE';
